import {
    ADECOAGRO_PATH,
    BUENBIT_PATH,
    FINAER_PATH,
    NEXT_ROLL_PATH,
    TOYOTA_PATH,
    PROOF_OF_INNOCENCE_PATH,
    STWO_PATH
} from '../routes'
import adecoagroProjectCardImage from '../media/clients/adecoagro-project-card.webp'
import finaerProjectCardImage from '../media/clients/finaer-project-card-image.webp'
import buenbitProjectCardImage from '../media/clients/buenbit-project-card-image.webp'
import nextrollProjectCardImage from '../media/clients/next-roll-project-card-image.webp'
import toyotaProjectCardImage from '../media/clients/toyota-project-card-image.webp'
import proofOfInnocenceCardImage from '../media/clients/proof-of-innocence-card-image.webp'
import stwoCardImage from '../media/clients/stwo-card-image.webp'


export function allProjectsCardsInformation(solutionsTexts) {
    const softwareDevelopmentProjects = softwareDevelopmentProjectsCardsInformation(solutionsTexts)
    const cryptographyProjects = cryptographyProjectsCardsInformation(solutionsTexts)
    const computerVisionProjects = computerVisionProjectsCardsInformation(solutionsTexts)

    return [...softwareDevelopmentProjects, ...cryptographyProjects, ...computerVisionProjects]
}

export function cryptographyProjectsCardsInformation(solutionsTexts) {
    const projects = {
        proofOfInnocence: {
            id: 'poi',
            title: solutionsTexts['solutionsProofOfInnocenceProjectTitle'],
            content: solutionsTexts['solutionsProofOfInnocenceProjectContent'],
            image: proofOfInnocenceCardImage,
            path: PROOF_OF_INNOCENCE_PATH,
            button: solutionsTexts['solutionsCardButton'],
        },
        stwo: {
            id: 'stwo',
            title: solutionsTexts['solutionsStwoProjectTitle'],
            content: solutionsTexts['solutionsStwoProjectContent'],
            image: stwoCardImage,
            path: STWO_PATH,
            button: solutionsTexts['solutionsCardButton'],
        }
    }
    return Object.values(projects)
}

export function computerVisionProjectsCardsInformation(solutionsTexts) {
    const projects = {
        adecoagro: {
            id: 'adecoagro',
            title: solutionsTexts['solutionsAdecoagroProjectTitle'],
            content: solutionsTexts['solutionsAdecoagroProjectContent'],
            image: adecoagroProjectCardImage,
            path: ADECOAGRO_PATH,
            button: solutionsTexts['solutionsCardButton'],
        },
        toyota: {
            id: 'toyota',
            image: toyotaProjectCardImage,
            title: solutionsTexts['solutionsToyotaProjectTitle'],
            content: solutionsTexts['solutionsToyotaProjectContent'],
            path: TOYOTA_PATH,
            button: solutionsTexts['solutionsProjectButton'],
        }
    }
    return Object.values(projects)
}

export function softwareDevelopmentProjectsCardsInformation(solutionsTexts) {
    const projects = {
        finaer: {
            id: 'finaer',
            title: solutionsTexts['solutionsFinaerProjectTitle'],
            content: solutionsTexts['solutionsFinaerProjectContent'],
            image: finaerProjectCardImage,
            path: FINAER_PATH,
            button: solutionsTexts['solutionsCardButton'],
        },
        nextroll: {
            id: 'nextroll',
            title: solutionsTexts['solutionsNextRollProjectTitle'],
            content: solutionsTexts['solutionsNextRollProjectContent'],
            image: nextrollProjectCardImage,
            path: NEXT_ROLL_PATH,
            button: solutionsTexts['solutionsCardButton'],
        },
        buenbit: {
            id: 'buenbit',
            title: solutionsTexts['solutionsBuenbitProjectTitle'],
            content: solutionsTexts['solutionsBuenbitProjectContent'],
            image: buenbitProjectCardImage,
            path: BUENBIT_PATH,
            button: solutionsTexts['solutionsCardButton'],
        }
    }
    return Object.values(projects)
}

export function otherProjectsWithout(aProjectName, aService, solutionsTexts) {
    switch (aService) {
        case 'softwareDevelopment':
            const softwareDevelopmentProjects = softwareDevelopmentProjectsCardsInformation(solutionsTexts)
            const softwareDevelopmentProjectsWithoutProjectSelected = softwareDevelopmentProjects.filter(
                project => project.id !== aProjectName)
            return projectsToShowContainingSameServiceProjects(softwareDevelopmentProjectsWithoutProjectSelected, aService, solutionsTexts)

        case 'cryptography':
            const cryptographyProjects = cryptographyProjectsCardsInformation(solutionsTexts)
            const cryptographyProjectsWithoutProjectSelected = cryptographyProjects.filter(
                project => project.id !== aProjectName)
            return projectsToShowContainingSameServiceProjects(cryptographyProjectsWithoutProjectSelected, aService, solutionsTexts)

        case 'computerVision':
            const computerVisionProjects = computerVisionProjectsCardsInformation(solutionsTexts)
            const computerVisionProjectsWithoutProjectSelected = computerVisionProjects.filter(
                project => project.id !== aProjectName)
            return projectsToShowContainingSameServiceProjects(computerVisionProjectsWithoutProjectSelected,aService, solutionsTexts)
    }
}

function otherServicesProjects(aService, solutionsTexts) {
    const softwareDevelopment = softwareDevelopmentProjectsCardsInformation(solutionsTexts)
    const cryptography = cryptographyProjectsCardsInformation(solutionsTexts)
    const computerVision = computerVisionProjectsCardsInformation(solutionsTexts)
    switch (aService) {

        case 'softwareDevelopment':
            return [...cryptography, ...computerVision]
        case 'cryptography':
            return [...computerVision, ...softwareDevelopment]
        case 'computerVision':
            return [...cryptography, ...softwareDevelopment]
    }
}

function projectsToShowContainingSameServiceProjects(sameServiceProjects, aService, solutionsTexts) {
    const numberOfTotalProjectsToShow = 3
    const numberOfProjectsOfSameService = sameServiceProjects.length
    if (numberOfProjectsOfSameService >= numberOfTotalProjectsToShow) {
        // TODO Fix this. Anyway, at this time we have less than 3 projects per service
        const shuffledSameService = sameServiceProjects.sort(() => Math.random() - 0.5);
        return shuffledSameService.slice(0, numberOfTotalProjectsToShow);
    }
    const numberOfExtraProjectsToShow = numberOfTotalProjectsToShow - numberOfProjectsOfSameService
    const otherProjects = otherServicesProjects(aService, solutionsTexts)
    const shuffledProjects = otherProjects.sort(() => Math.random() - 0.5)
    const extraProjects = shuffledProjects.slice(0, numberOfExtraProjectsToShow)

    return [...sameServiceProjects, ...extraProjects]
}